export default __webpack_public_path__ + "static/media/falcon_join_3.5566484d.svg";